import React, { useState } from "react";
import ProductsAdmin from "./ProductsAdmin";
import CategoryAdmin from "./CategoryAdmin";
import BrandAdmin from "./BrandAdmin";
import BikeModelAdmin from "./BikeModelAdmin";
import Adminpost from "./Adminpost";
import "./Adminproductlist.css";
import Coloradd from "./Coloradd";

function Adminproductlist() {
  const [active, setActive] = useState("products");

  return (
    <div className="admin-container">
      <div className="admin-tabs">
        <button className={active === "products" ? "active" : ""} onClick={() => setActive("products")}>
          Products
        </button>

        <button className={active === "categories" ? "active" : ""} onClick={() => setActive("categories")}>
          Categories
        </button>

        <button className={active === "brands" ? "active" : ""} onClick={() => setActive("brands")}>
          Brands
        </button>

        <button className={active === "models" ? "active" : ""} onClick={() => setActive("models")}>
          Bike Models
        </button>

        <button className={active === "posts" ? "active" : ""} onClick={() => setActive("posts")}>
          Posts
        </button>
        <button className={active === "color" ? "active" : ""} onClick={() => setActive("color")}>
          Colors
        </button>
      </div>
      <div className="admin-content">
        {active === "products" && <ProductsAdmin />}
        {active === "categories" && <CategoryAdmin />}
        {active === "brands" && <BrandAdmin />}
        {active === "models" && <BikeModelAdmin />}
        {active === "posts" && <Adminpost />}
        {active === "color" && <Coloradd />}
      </div>
    </div>
  );
}

export default Adminproductlist;
